import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function NuestroAceite() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="nuestro-aceite" className="relative w-full py-12 md:py-9 lg:py-12 flex items-center justify-center overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1552070/img/sun_drenched_olive_grove.png" alt="Sun-drenched Spanish olive grove" className="w-full h-full object-cover" />
        {}
        <div className="absolute inset-0 bg-secondary-100/60 backdrop-blur-[2px]" />
      </div>

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-4 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <h1 className="font-serif text-[rgb(245,241,229)] font-semibold text-5xl md:text-[4rem] leading-[1.2]">
          Nuestro aceite
        </h1>
        <p className="mt-8 font-sans text-foreground text-lg leading-[1.8] max-w-[600px]">
          Cultivado bajo el sol de España, nuestro aceite de oliva virgen extra
          captura la esencia de la tierra. Cada gota es el resultado de una
          tradición milenaria, cuidada con pasión para ofrecer un sabor puro,
          equilibrado y lleno de matices que elevan cualquier experiencia
          culinaria.
        </p>
      </div>
    </section>;
}